function info_box() {
  jQuery('.item-box').find('span').each(function() {
    var plus = jQuery(this);
    var item = plus.data('info');
    var offset = plus.offset();
    var left = 0;
    var top = 0;
    var is_mobile = false;
    
    if (window.innerWidth >= 1200) {
      if(plus.hasClass('info-even')) {
        left = offset.left+60;
        top = offset.top-50;
      } else {
        left = offset.left-330;
        top = offset.top-50;        
      }
    } else {
      if(window.innerWidth >= 760) {
        if(plus.hasClass('info-even')) {
          left = offset.left-170;
          top = offset.top+50;
        } else {
          left = offset.left-100;
          top = offset.top+50;        
        }
      } else {
        is_mobile = true;
        //mobile here - absolute position for info-boxes

      }
    }
    if(is_mobile == false) {
      jQuery('#'+item+'-info').offset({ top: top, left: left });
    }
  });
}
jQuery(document).ready(function() {
  var maxScroll = 200; // Maximum separation distance
  if (window.innerWidth <= 572) {
    maxScroll = 100; // Reduce max distance for mobile
  }

  info_box();

  $(window).on("scroll", function () {
    var scrollTop = jQuery(window).scrollTop();
    var offset = Math.min(scrollTop, maxScroll);
    offset = offset/4;

    // Update .hydro-item bottom-margin by `offset` pixels
    jQuery(".hydro-item").css("margin-bottom", offset + "px");

    info_box();
  });

  // Adjust on window resize
  $(window).on("resize", function () {
    if (window.innerWidth <= 572) {
      maxScroll = 100;
    } else {
      info_box();
      maxScroll = 200;
    }
  });

  /* Toggle Info Box Visibility */
  jQuery('.item-box').find('span').click(function() {
    var active = jQuery('span.active-box').data('info');
    var item = jQuery(this).data('info');
    
    jQuery('.item-box').find('span').removeClass('active-box');
    jQuery('.info-box').css('visibility','hidden');
    
    if(active != item) {
      jQuery(this).addClass('active-box');
      jQuery('#'+item+'-info').css('visibility','visible');
    }
  });
});